// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dialog--confirm-delete-widget .content-text{width:450px;max-width:100%}.dialog--confirm-delete-widget .action{margin-left:7px}", ""]);
// Exports
module.exports = exports;
